<script lang="ts">
    import { _ } from "svelte-i18n"
    import { navigate } from "svelte-routing"
    import { sliderImageCursor } from "../../store"

    import Image from "../widgets/Image.svelte"

    export let project: Content
    export let show: boolean = false
    // export let index: number = 0
</script>

{#if project && show}
    <div
        class="project-tile"
        on:click="{() => {
            navigate(project.path)
            $sliderImageCursor.element.classList.remove('show')
        }}"
        on:keydown
    >
        <div class="project-image">
            <Image entryId="{project.id}" file="{project?.project?.media?.mainImage}" />
        </div>
        <div class="project-info">
            <div class="project-title">
                {@html project?.project?.general?.title}
            </div>
            <div class="project-category">
                {#if Array.isArray(project?.project?.general?.category)}
                    {#each project?.project?.general?.category as category}
                        {$_("project.categories." + category)} &nbsp; &nbsp;
                    {/each}
                {:else}
                    {$_("project.categories." + project?.project?.general?.category)}
                {/if}
            </div>
            <div class="project-status">
                {$_("project.status." + project?.project?.general?.status)}
            </div>
        </div>
    </div>
{/if}
